import React,{Component} from 'react';
// import Show from './Show.js'
import Searche from './Searche.js'
import Transaction from './Transaction.js'
import {firestore} from '../../firebase/firebase.utils'
class Admin extends Component {
	constructor(props){
		super(props);
		this.state = {
			showUsers:false,
			users:[],
			returned:false,
			status:'',
			pass:''
		}
	}
	componentDidMount() {
        const that = this;
        let c = []
        firestore.collection("users").get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                c.push(doc.data())
        });
        that.setState({users:c})
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
      }
	render(){
		return(
			<div>
			<Searche users={this.state.users}/>
			{/* <Show/> */}
			<Transaction/>
	  </div>
		);
	}
}
export default Admin